import React from 'react';
import { JiraSprintData } from '../../../../api/endpoints/jira';
import { MenuButton } from '../../../../ui/MenuButton';
import { JiraSprintMenu } from './JiraSprintMenu';

export type JiraSprintPickerProps = {
    jiraProjectId: string,
    selected: JiraSprintData,
    onChange(next: JiraSprintData): void,
};

export const JiraSprintPicker = ({ jiraProjectId, selected, onChange }: JiraSprintPickerProps) => {

    const label = selected?.name || 'Sprint';

    return <MenuButton block label={label}>
        <JiraSprintMenu
            jiraProjectId={jiraProjectId}
            selected={selected ? [selected] : []}
            onSelect={onChange} />
    </MenuButton>;
};
